module.exports = __webpack_public_path__ + "img/errorBs.cfb7c928.png";